export const LABEL_CLASS_NAME = 'pharmsnap-highlight'
export const LABEL_INFO_CLASS_NAME = 'pharmsnap-highlight__info'
export const DATA_NAME__LABEL_NAME = 'data-label'
export const DATA_NAME__LABEL_ID = 'data-label-id'
export const DATA_NAME__NOR_ID = 'data-nor-id'
export const DATA_NAME__LABEL_UNIQUE_ID = 'data-unique-id'
export const DATA_NAME__LABEL_INDEX = 'data-index'
export const DATA_NAME__LABEL_DISABLE_DELETE = 'data-disable-delete'
